import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{ background: '#1E230F', fontFamily: "'Sora', sans-serif" }} className="text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/77ede6cfebdeef4356c517ccc70ad5e9/177ec42a90177c346f55db4cbfb1cc8d.png"
              alt="Logo Vinícola Suave"
              className="h-36 w-auto object-contain mb-4"
            />
            <p className="text-[#FCF1D7]/60 text-sm leading-relaxed">
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;PRODUTOS QUE VENDEM!
&nbsp;se você é dono de mercado, casa de carnes e até agropecuária, nossos produtos são o que você precisa para faturar mais
            </p>
          </div>

          {/* Produtos */}
          <div>
            <h4 className="text-[#878450] font-semibold text-sm mb-4 pb-3 border-b border-[#878450]/30" style={{ fontFamily: "'Playfair Display', serif" }}>
              <a href="#produtos">Produtos</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/vinhos" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Vinhos em PET</Link></li>
              <li><Link to="/vinagre" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Vinagre Colonial</Link></li>
              <li><Link to="/suco" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Suco de Uva Integral</Link></li>
            </ul>
          </div>

          {/* Navegação */}
          <div>
            <h4 className="text-[#878450] font-semibold text-sm mb-4 pb-3 border-b border-[#878450]/30" style={{ fontFamily: "'Playfair Display', serif" }}>
              <a href="#navegacao">Navegação</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Início</Link></li>
              <li><Link to="/vinhos" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Vinhos</Link></li>
              <li><Link to="/vinagre" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Vinagre</Link></li>
              <li><Link to="/suco" className="text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer">Suco de Uva</Link></li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-[#878450] font-semibold text-sm mb-4 pb-3 border-b border-[#878450]/30" style={{ fontFamily: "'Playfair Display', serif" }}>
              <a href="#contato">Contato</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://wa.me/5500000000000"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-2.5 text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer"
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-whatsapp-line text-sm"></i>
                  </span>
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/guarnierimorangosevinhos/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-2.5 text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer"
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-facebook-fill text-sm"></i>
                  </span>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/guarnieri_morangosevinhos/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-2.5 text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer"
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-instagram-line text-sm"></i>
                  </span>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@vinicola.com.br"
                  className="flex items-center gap-2.5 text-[#FCF1D7]/60 text-sm hover:text-[#878450] transition-colors cursor-pointer"
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-mail-line text-sm"></i>
                  </span>
                  E-mail
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-6 border-t border-[#878450]/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#FCF1D7]/40 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Vinícola Suave. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://wa.me/5500000000000"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-[#FCF1D7]/60 hover:bg-[#710005] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-line text-sm"></i>
            </a>
            <a
              href="https://www.facebook.com/guarnierimorangosevinhos/"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-[#FCF1D7]/60 hover:bg-[#710005] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill text-sm"></i>
            </a>
            <a
              href="https://www.instagram.com/guarnieri_morangosevinhos/"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-[#FCF1D7]/60 hover:bg-[#710005] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a
              href="mailto:contato@vinicola.com.br"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-[#FCF1D7]/60 hover:bg-[#710005] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-mail-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
